import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import styles from './styles.module.scss';

const SearchStatusText: React.FC<{ children: React.ReactNode; totalHits: number | undefined }> = props => {
  return (
    <div>
      <Spacer size={'m'} />
      <div className={props.totalHits && props.totalHits > 0 ? styles['search__status'] : ''}>{props.children}</div>
      <Spacer size={'m'} />
    </div>
  );
};

export default SearchStatusText;
